/** @format */
import { type UserContext } from '@mpb-com/auth-sdk/client';

import { User } from '@toucan/common/services/user/types';

import { IdentityKind } from '../config/constants';
import { Identity } from '../config/types';

export const getIdentity = (
    isLoggedIn: boolean,
    user?: User,
    userContext?: UserContext
): Identity | null => {
    if (!isLoggedIn) {
        return { kind: IdentityKind.ANONYMOUS };
    }

    if (userContext && user === undefined) {
        return { kind: IdentityKind.OAUTH, userContext };
    }

    if (user?.customerId !== undefined) {
        return { kind: IdentityKind.CUSTOMER, customerId: user.customerId };
    }

    return null;
};

export const getIdentityKey = (identity: Identity): string => {
    switch (identity.kind) {
        case IdentityKind.CUSTOMER:
            return `${IdentityKind.CUSTOMER}:${identity.customerId}`;
        case IdentityKind.OAUTH:
            return `${IdentityKind.OAUTH}:${identity.userContext.subject}`;
        case IdentityKind.ANONYMOUS:
            return IdentityKind.ANONYMOUS;
        default: {
            const exhaustiveCheck: never = identity;

            return exhaustiveCheck;
        }
    }
};
